<template>
  <div :data-refapp-tagging-id="taggingId">
    <refapp-video-youtube v-if="isYoutube">
      <slot></slot>
    </refapp-video-youtube>
    <refapp-video-base v-else>
      <slot></slot>
    </refapp-video-base>
  </div>
</template>

<script>
import { initTagging } from '../lib/tagging';
import RefappVideoBase from './base/video.vue';
import RefappVideoYoutube from './base/video-youtube.vue';

export default {
  name: 'refapp-video',
  components: {
    RefappVideoBase,
    RefappVideoYoutube,
  },
  inject: ['youtubeId', 'taggingId'],
  computed: {
    isYoutube() {
      return !!this.youtubeId;
    },
  },
  mounted() {
    initTagging(this.taggingId);
  },
};
</script>
